import { lazy, Suspense } from 'react';
import { View, StyleSheet } from 'react-native';
import { theme } from '@/constants/theme';
import type { Course } from '@/types/chat';

const CoursesGrid = lazy(() =>
  import('./CoursesGrid').then(mod => ({ default: mod.CoursesGrid }))
);

interface Props {
  courses: Course[];
  onBookCall: (course: Course) => void;
  onMentorClick?: (mentorName: string) => void;
  onAllAnimationsComplete?: () => void;
}

export function LazyCoursesGrid(props: Props) {
  // ✅ FIX: fallback with real height based on course count so FlatList
  // doesn't collapse the grid row to 0 while CoursesGrid lazy-loads.
  // Each card is ~180px + gap, so we approximate the total height.
  const estimatedHeight = Math.max(180, props.courses.length * (180 + theme.spacing.md));

  return (
    <Suspense fallback={<View style={[styles.placeholder, { height: estimatedHeight }]} />}>
      <CoursesGrid {...props} />
    </Suspense>
  );
}

const styles = StyleSheet.create({
  placeholder: {
    width: '100%',
    paddingHorizontal: theme.spacing.md,
  },
});